import { jsx } from "react/jsx-runtime";
import AntForm from "antd/es/form";
import classnames from "../../utils/classnames.js";
import './Form.css';/* empty css          */
const defaultNormalize = (v) => {
  if (typeof v === "string") {
    return v.trimStart();
  }
  return v;
};
const InternalFormItem = function FormItem({
  className,
  hiddenLabel,
  loading,
  valuePropName,
  normalize = defaultNormalize,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    AntForm.Item,
    {
      valuePropName: loading ? "noValue" : valuePropName,
      normalize,
      className: classnames(
        [
          "perxis-auto-form-item",
          {
            "perxis-auto-form-item--hidden-label": hiddenLabel
          }
        ],
        className
      ),
      ...props
    }
  );
};
const FormItem2 = InternalFormItem;
FormItem2.useStatus = AntForm.Item.useStatus;
export {
  InternalFormItem as default
};
//# sourceMappingURL=FormItem.js.map
